import { create } from "zustand"

import { ShopItem } from "../../../../../types"

export enum InventoryGiftShopModalTab {
  INVENTORY = "inventory",
  GIFT_SHOP = "gift-shop",
}

interface InventoryGiftShopModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  selectedTab: InventoryGiftShopModalTab
  setSelectedTab: (tab: InventoryGiftShopModalTab) => void

  selectedShopItem: ShopItem | null
  setSelectedShopItem: (shopItem: ShopItem) => void
}

export const useInventoryGiftShopModalStore =
  create<InventoryGiftShopModalStore>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),

    selectedTab: InventoryGiftShopModalTab.INVENTORY,
    setSelectedTab: (tab: InventoryGiftShopModalTab) =>
      set({ selectedTab: tab }),

    selectedShopItem: null,
    setSelectedShopItem: (shopItem: ShopItem) =>
      set({ selectedShopItem: shopItem }),
  }))
